import csuLibrary from '@/pages/layouts/csu-pages/Library.vue'
import csuHome from '@/pages/layouts/csu-pages/Home'
import csuGame from '@/pages/layouts/csu-pages/Game'
import csuQuizs from '@/pages/layouts/csu-pages/quiz/Quizs.vue'


export const csuRouter = [{
  path: '/csu',
  name: 'csuHome',
  component: csuHome,
  meta: {
    keepAlive: true // 需要缓存
  }
},
// {
//   path: '/csu/library',
//   name: 'csuLibrary',
//   component: csuLibrary,
//   meta: {
//     keepAlive: true // 需要缓存
//   }
// },
{
  path: '/csu/discover',
  name: 'csuGame',
  component: csuGame,
  meta: {
    keepAlive: true // 需要缓存
  }
}, {
  path: '/csu/quizs',
  name: 'csuQuizs',
  component: csuQuizs,
  meta: {
    keepAlive: true // 需要缓存
  }
}]



// WEBPACK FOOTER //
// ./src/router/layout-router/csu-router.js